import styled from 'styled-components'

export const ContainerList = styled.div`
  width: 100%;
`

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 0;

  :not(:last-child) {
    border-bottom: 1px solid #c3c3c3;
  }
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 36px;
    height: 36px;
    color: #000;
  }
`

interface PreviewProps {
  src?: string;
}

export const Preview = styled.div<PreviewProps>`
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  margin-right: 14px;
`

export const IconPreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border: 1px solid #c3c3c3;
  border-radius: 5px;
  margin-right: 14px;

  svg {
    width: 21px;
    height: 26px;
  }
`

export const FileNameText = styled.div`
  p {
    color: #4b4b4b;
    width: 235px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const TrashIconWrapper = styled.div`
  cursor: pointer;
  svg {
    height: 36px;
    width: 36px;
  }
`

export const Info = styled.div``

export const FileSize = styled.div`
  margin-top: 3px;
  p{
    color: #898989;
  }
`
